import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import CustomerDashboard from './pages/customer/CustomerDashboard';
import PrisonDashboard from './pages/prison/PrisonDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import Login from './pages/Login';
import OrderConfirmation from './pages/customer/OrderConfirmation';
import ChatWidget from './components/ChatWidget';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-government-50 to-government-100 dark:from-government-900 dark:to-government-800 transition-colors duration-300">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/login" element={<Login />} />
                <Route path="/customer/*" element={<CustomerDashboard />} />
                <Route path="/prison/*" element={<PrisonDashboard />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
                <Route path="/order-confirmation" element={<OrderConfirmation />} />
              </Routes>
            </motion.div>
            
            {/* Global Chat Widget */}
            <ChatWidget />
          </div>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;